import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    sx: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 'auto', // Adjust dropdown width
      borderRadius: 2, // Rounded corners
      boxShadow: 3, // Add shadow for elevation
      bgcolor: 'white', // Background color
    },
  },
};

// Array with custom values
const platforms = [
  { label: 'Amazon', value: 'amazon' },
  { label: 'Flipkart', value: 'flipkart' },
  { label: 'Snapdeal', value: 'snapdeal' },
  { label: 'Tata 1mg', value: 'tata_1mg' },
  { label: 'First Cry', value: 'first_cry' },
  { label: 'Netmeds', value: 'netmeds' },
  { label: 'Zepto', value: 'zepto' },
  { label: 'Blinkit', value: 'blinkit' },
  { label: 'Bigbasket', value: 'bigbasket' },
  { label: 'Instamart(by Swiggy)', value: 'instamart' },
];

function getStyles(value, selectedOptions, theme) {
  return {
    fontWeight: selectedOptions.includes(value)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
  };
}

const MultipleSelectPlatformsMUI = ({
  selectedOptions,
  setSelectedOptions,
}) => {
  const theme = useTheme();

  const handleChange = (event) => {
    const { value } = event.target;
    setSelectedOptions(typeof value === 'string' ? value.split(',') : value);
  };

  return (
    <FormControl
      sx={{
        m: 1,
        width: 250, // Adjust width
        '& .MuiInputLabel-root': {
          fontSize: '16px', // Label font size
          // fontWeight: 'bold',
        },
        '& .MuiOutlinedInput-root': {
          // padding: '10px', // Adjust input padding
          borderRadius: 2, // Rounded corners
          '& fieldset': {
            borderColor: 'gray', // Default border color
          },
          '&:hover fieldset': {
            // borderColor: 'blue', // Hover border color
          },
          '&.Mui-focused fieldset': {
            borderColor: 'green', // Focus border color
          },
        },
      }}
    >
      <InputLabel id='demo-multiple-platform-label'>Platforms</InputLabel>
      <Select
        labelId='demo-multiple-platform-label'
        id='demo-multiple-platform'
        multiple
        value={selectedOptions}
        onChange={handleChange}
        input={<OutlinedInput label='Platforms' />}
        MenuProps={MenuProps}
      >
        {platforms.map((platform) => (
          <MenuItem
            key={platform.value}
            value={platform.value}
            sx={{
              fontSize: '14px',
              padding: '10px 20px', // Adjust padding inside menu
              '&:hover': {
                backgroundColor: 'lightgray',
              },
              '&.Mui-selected': {
                // backgroundColor: '#1976d2', // Change selected color
                // color: 'white',
                '&:hover': {
                  // backgroundColor: '#115293', // Darker hover effect
                },
              },
            }}
          >
            {platform.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default MultipleSelectPlatformsMUI;
